import { styled } from 'styled-components';
import { Card, Form } from 'antd';

export const ContentCard = styled(Card)`
  max-width: 800px;
  margin: 0 auto;
`;

export const CurrentCapacityDisplay = styled.section`
  background: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  text-align: center;
`;

export const CapacityNumber = styled.span`
  font-size: 48px;
  font-weight: bold;
  color: #1890ff;
  margin: 0 8px;
`;

export const CapacityValueContainer = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserList = styled.section`
  margin-bottom: 24px;
`;

export const UserItem = styled.article`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 8px;
  background: #fff;
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  flex-direction: column;
`;

export const UserControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const UserFormItem = styled(Form.Item)`
  margin: 0;
`;

export const FormStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
} as const;
